import { EnhancedPayrollReport } from '@reporting/interfaces/report.interface';
import { getInitialDatesForEntireYear } from '../dates';

export const WorkersCompensationReporting: EnhancedPayrollReport = {
    name: 'reporting.payroll.workersCompensation.name',
    description: 'reporting.payroll.workersCompensation.description',
    routerLink: 'workers-compensation',
    reportName: 'workersCompensationReport',
    fileName: '',
    hasExcel: false,
    hasPDF: false,
    hasCSV: true,
    allowsInclusionOfPendingPayrolls: true,
    showsPeriod: true,
    filterable: true,
    isAnnual: true,

    getInitialDates: getInitialDatesForEntireYear,
};
